module.exports = __webpack_public_path__ + "static/media/NaturePeople.d.1e5ddb14.ts";


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-icons/NaturePeople.d.ts
// module id = 2671
// module chunks = 0